<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <vendor-field
          slot="pi_vendname"
          :label="customLabel.pi_vendname || '供应商'"
          v-model="form.main.pi_vendname"
          @select="onSelectVendor"
        />
        <vendor-ct-field
          slot="pi_contact"
          v-model="form.main.pi_contact"
          :label="customLabel.pi_contact || '联系人'"
          :vendor-id="form.main.pi_vendid"
          v-if="form.main.pi_vendname"
        />
        <div class="weui-cell" v-if="form.main.pi_tel" slot="pi_tel">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pi_tel || "联系电话"
            }}</label>
          </div>
          <div class="weui-cell__bd">{{ form.main.pi_tel }}</div>
        </div>
        <payment-field
          slot="pi_payments"
           :label="customLabel.pi_payments || '付款方式'"
          :is-rec="false"
          v-model="form.main.pi_payments"
          @select="onSelectPayment"
        />
        <currency-field
          slot="pi_currency"
           :label="customLabel.pi_currency || '币种'"
          v-model="form.main.pi_currency"
          @select="onSelectCurrency"
        />
        <div class="weui-cell" slot="pi_taxrate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pi_taxrate || "税率"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.pi_taxrate"
              @change="calcItem()"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="pi_sendcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pi_sendcode || "送货单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.pi_sendcode"
              placeholder="请输入"
            />
          </div>
        </div>
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <custom-layout
          class="weui-cells"
          :view-config="customViewConfig"
          position="detail1"
        >
          <div class="weui-cell" v-if="item.pd_prodcode" slot="pd_prodcode">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.pd_prodcode || "产品编号"}}</label>
            </div>
            <div class="weui-cell__bd">{{item.pd_prodcode}}</div>
          </div>
          <product-field slot="pr_detail"
          :label="customLabel.pr_detail || '产品名称'"
            v-model="item.productDTO.pr_detail"
            @select="onSelectProduct($event, item)"
          />
          <div class="weui-cell" v-if="item.productDTO.pr_orispeccode" slot="pr_orispeccode">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.pr_orispeccode || "型号"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              {{ item.productDTO.pr_orispeccode }}
            </div>
          </div>
          <div class="weui-cell" v-if="item.productDTO.pr_spec" slot="pr_spec">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.pr_spec || "规格"
            }}</label>
            </div>
            <div class="weui-cell__bd">{{ item.productDTO.pr_spec }}</div>
          </div>
          <warehouse-field slot="pd_whname" v-model="item.pd_whname" @select="onItemSelectWarehouse($event, item)" />
          <div class="weui-cell" slot="pd_inqty">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.pd_inqty || "数量"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.pd_inqty"
                @change="calcItem(item)"
                placeholder="请填写"
              />
            </div>
            <div class="weui-cell__ft">{{ item.productDTO.pr_unit }}</div>
          </div>
          <div class="weui-cell" v-if="item.productDTO.pr_unit_extra">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                "辅助数量"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                :value="$number.round(item.pd_inqty / item.productDTO.pr_denominator * item.productDTO.pr_numerator || 0, 3)"
                @input="oninputQty($event, item)"
                placeholder="请填写"
              />
            </div>
            <div class="weui-cell__ft">{{ item.productDTO.pr_unit_extra }}</div>
          </div>
          <div class="weui-cell" slot="pd_netprice">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.pd_netprice || "不含税单价"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.pd_netprice"
                @change="calcItem(item)"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" v-if="item.pd_netprice" slot="pd_nettotal">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.pd_nettotal || "不含税金额"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              {{ numberFormat(item.pd_nettotal,'¥#,##0.00') }}
            </div>
          </div>
          <custom-field 
            :label="customLabel.pd_text1 || '自定义字段1'"
            v-model="item.pd_text1" :caller="caller" fieldName="pd_text1"
            slot="pd_text1" hidden="true"
          />
          <custom-field
            :label="customLabel.pd_text2 || '自定义字段2'"
            v-model="item.pd_text2" :caller="caller" fieldName="pd_text2"
            slot="pd_text2" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text3 || '自定义字段3'"
            v-model="item.pd_text3" :caller="caller" fieldName="pd_text3"
            slot="pd_text3" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text4 || '自定义字段4'"
            v-model="item.pd_text4" :caller="caller" fieldName="pd_text4"
            slot="pd_text4" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text5 || '自定义字段5'"
            v-model="item.pd_text5" :caller="caller" fieldName="pd_text5"
            slot="pd_text5" hidden="true"
          />
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </custom-layout>
      </div>
      <div class="weui-cells">
        <file-field v-model="form.main.pi_attach" ref="pi_attach" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import VendorField from "@/components/field/VendorField.vue";
import FileField from "@/components/field/FileField.vue";
import VendorCtField from "@/components/field/VendorCtField.vue";
import PaymentField from "@/components/field/PaymentField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import ProductField from "@/components/field/ProductField.vue";
import WarehouseField from "@/components/field/WarehouseField.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  components: {
    CustomLayout,
    VendorField,
    FileField,
    VendorCtField,
    PaymentField,
    CurrencyField,
    ProductField,
    WarehouseField,
    CustomField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/purchase/prodinout",
      codeField: "pi_pucode",
      statusField: "pi_statuscode",
      caller: "PurchaseIn",
      xtype: "purchase-purchasein-formpanel",
      form: {
        main: {
          pi_vendname: null,
          pi_vendid: null,
          pi_contact: null,
          pi_tel: null,
          pi_payments: null,
          pi_currency: null,
          pi_taxrate: 0,
        },
        items: [
          {
            pd_inqty: 0,
            pd_netprice: 0,
            pd_nettotal: 0,
            pd_price: 0,
            pd_total: 0,
            pd_taxamount: 0,
            productDTO: {},
          },
        ],
      },
    };
  },
  created() {
    this.getData();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getData();
    });
  },
  methods: {
    getData() {
      var me = this,
        id = me.$route.query.id;
      if (id) {
        me.f_get(function () {}, id);
      }
    },
    /**
     * 选择供应商
     */
    onSelectVendor(selection) {
      var me = this,
        main = me.form.main;
      main.pi_vendid = selection.id;
      main.pi_vendcode = selection.ve_code;
      main.pi_buyerid = selection.ve_buyerid;
      main.pi_buyercode = selection.ve_buyercode;
      main.pi_buyername = selection.ve_buyername;
      main.pi_currency = selection.ve_currency;
      main.pi_rate = selection.cr_rate;
      main.pi_contact = selection.vc_name;
      main.pi_tel = selection.vc_tel;
      main.pi_paymentsid = selection.ve_paymentsid;
      main.pi_paymentscode = selection.ve_paymentscode;
      main.pi_payments = selection.ve_payments;
      main.pi_taxrate = selection.ve_taxrate;
    },
    /**
     * 选择付款方式
     */
    onSelectPayment(selection) {
      var me = this,
        main = me.form.main;
      main.pi_paymentsid = selection.id;
      main.pi_paymentscode = selection.pa_code;
    },
    /**
     * 选择币种
     */
    onSelectCurrency(selection) {
      var me = this,
        main = me.form.main;
      main.pi_rate = selection.cr_rate;
    },
    /**
     * 选择明细产品
     */
    onSelectProduct(selection, item) {
      item.pd_prodid = selection.id;
      item.pd_prodcode = selection.pr_code;
      item.productDTO = Object.assign({}, selection);
    },
    /**
     * 输入辅助数量
     */
    oninputQty(e, item) {
      item.pd_inqty = e.target.value / item.productDTO.pr_numerator * item.productDTO.pr_denominator
      this.calcItem(item)
    },
    /**
     * 计算单价、金额
     */
    calcItem(selection) {
      var me = this,
        main = me.form.main,
        tr = main.pi_taxrate || 0,
        items = selection ? [selection] : me.form.items;
      items.forEach((item) => {
        item.pd_inqty = me.$number.round(item.pd_inqty || 0, 3);
        item.pd_netprice = me.$number.round(item.pd_netprice || 0, 6);
        item.pd_nettotal = me.$number.round(item.pd_inqty * item.pd_netprice, 2);
        item.pd_price = me.$number.round(item.pd_netprice * (1 + tr / 100), 6);
        item.pd_total = me.$number.round(item.pd_inqty * item.pd_price, 2);
        item.pd_taxamount = item.pd_total - item.pd_nettotal;
      });
    },
    onItemSelectWarehouse(selection, item) {
      item.pd_whid = selection.id;
      item.pd_whcode = selection.wh_code;
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.pi_vendname) {
        me.$weui.topTips("请选择供应商", 2000);
      } else if (!main.pi_payments) {
        me.$weui.topTips("请选择付款方式", 2000);
      } else if (!main.pi_currency) {
        me.$weui.topTips("请选择币种", 2000);
      } else {
        main.pi_taxrate = main.pi_taxrate || 0;
        var count = 0,
          total = 0,
          nettotal = 0,
          tax = 0;
        items.forEach(function (item) {
          if (!item.pd_prodid) {
            me.$weui.topTips(`第${count + 1}行产品未选择`, 2000);
            return false;
          } else if (!item.pd_inqty || item.pd_inqty <= 0) {
            me.$weui.topTips(`第${count + 1}行数量未填写`, 2000);
            return false;
          } else {
            count++;
            item.pd_pdno = count;
            item.pd_taxrate = main.pi_taxrate;
            // 合计
            total += item.pd_total;
            nettotal += item.pd_nettotal;
            tax += item.pd_taxamount;
          }
        });
        checked = count == items.length;
        main.pi_total = total;
        main.pi_nettotal = nettotal;
        main.pi_taxtotal = tax;
      }

      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
        return;
      } 

      me.f_deleteDetail(items[index].id, function () {
        items.splice(index, 1);
      });
      
    },

    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        pd_inqty: 0,
        pd_netprice: 0,
        pd_nettotal: 0,
        pd_price: 0,
        pd_total: 0,
        pd_taxamount: 0,
        productDTO: {},
      });
    },
  },
};
</script>